import {
  type FinCategory,
  getCategoryExperience,
} from '#dictionary/finCategories'

type FormatCategoryNameOptions = {
  with?: 'experience' | 'group'
}

export const formatCategoryName = (
  category: FinCategory,
  options: FormatCategoryNameOptions = {}
): string => {
  const experience = getCategoryExperience(category)
  const parts =
    options.with === 'group'
      ? [experience.finGroup, experience.name, category.name]
      : options.with === 'experience'
        ? [experience.name, category.name]
        : [category.name]
  return parts.filter(Boolean).join(' / ')
}
